import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b766c3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "breadcrumb" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "已创建的选品单", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 返回商品库 ")
const _hoisted_4 = { class: "tab" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 查看/修改 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 生成报价单 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 下载选品单 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 生成下单链接 ")
const _hoisted_9 = { class: "pagination" }
const _hoisted_10 = { class: "left" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "每页显示", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "条，共计", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_14 = { class: "dialog-footer" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("下一步")
const _hoisted_16 = { class: "title" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 新增账号 ")
const _hoisted_18 = { class: "info" }
const _hoisted_19 = { class: "name" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "姓名", -1))
const _hoisted_21 = { class: "mobile" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "手机号", -1))
const _hoisted_23 = { class: "add" }
const _hoisted_24 = { class: "dialog-footer" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("复制链接")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("完成")

import { ref, onMounted, watch, reactive, toRefs } from 'vue'
import { $post, $exportExcel } from '@/utils/https'
import { useRouter } from 'vue-router'
import { Selections, Selection } from '@/model/selection'
import { ElMessageBox, ElMessage } from 'element-plus'
import Header from '@/components/header'
import PreOrder from '@/views/preOrder'
interface State {
  tableData: Selection[]
  pageSizeOpt: number[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const hrProductUrl = ref('')
const router = useRouter()
const preOrderRef = ref<any>(null)
const bindCompanyDialog = ref(false)
const dialogSelectionVisible = ref(false)
const bindUserDialog = ref(false)
const selectionId = ref(0)
const bindCompanyOptions = ref([])
const hrList = ref([])
const state = reactive<State>({
  tableData: [],
  pageSizeOpt: [20, 30, 50]
})
const pageSize = ref(20)
const pageIndex = ref(1)
const total = ref(0)
const searchName = ref('')
const bindCompany = ref('')

onMounted(() => {
  getSelectionList('')
})
watch(
  () => pageSize.value,
  () => {
    if (pageIndex.value === 1) {
      getSelectionList(searchName.value)
      return
    }
    pageIndex.value = 1
  }
)
watch(
  () => pageIndex.value,
  (val: number) => {
    pageIndex.value = val
    getSelectionList(searchName.value)
  }
)

const search = (val: string) => {
  searchName.value = val
  if (pageIndex.value === 1) {
    getSelectionList(val)
  } else {
    pageIndex.value = 1
  }
}
const handleEdit = (id: number) => {
  router.push({
    path: '/selectionEdit',
    query: {
      id: id
    }
  })
}
const getSelectionList = (name?: string) => {
  $post<Selections>({
    url: '/order/selection/list',
    data: {
      selection_name: name,
      page: pageIndex.value,
      page_size: pageSize.value
    }
  }).then((res) => {
    total.value = res.data.total
    state.tableData = [].concat(res.data.data || [])
  })
}
const cellClass = (val) => {
  if (val.column.label === '产品图') {
    return 'i-cell-img-class'
  }
}
const headerCellClass = () => {
  return 'i-header-cell-class'
}
const navPreOrder = (id: number) => {
  selectionId.value = id
  dialogSelectionVisible.value = true
}
const closeSelectionDialog = () => {
  dialogSelectionVisible.value = false
}
const dialogSelectionClose = () => {
  preOrderRef.value.clearData()
}
const navProducts = () => {
  router.push('products')
}
const handleDownload = (id: number) => {
  $exportExcel({
    url: '/order/selection/export',
    loading: true,
    data: {
      id: id
    }
  }).then((res) => {
    if (!res.data) return
    const blob = new Blob([res.data], {
      type: 'application/vnd.ms-excel;charset=utf8'
    })
    const url = window.URL.createObjectURL(blob)
    const aLink = document.createElement('a')
    aLink.style.display = 'none'
    aLink.href = url
    // const splits = res.headers['content-disposition'].split('filename=')
    aLink.setAttribute('download', `选品单${new Date().getTime()}.xlsx`)
    document.body.appendChild(aLink)
    aLink.click()
    ElMessageBox.alert('您已成功下载选品单,可在下载中心查看！', '', {
      confirmButtonText: '确定',
      showClose: false,
      center: true,
      callback: () => {}
    })
    setTimeout(() => {
      window.URL.revokeObjectURL(url) // 释放URL 对象
      document.body.removeChild(aLink)
    }, 500)
  })
}
const handleBindCompany = (id:number) => {
  selectionId.value = id
  hrProductUrl.value = `https://www.banmei.com.cn/hr/#/products?id=${id}`
  bindCompany.value = ''
  $post<Selections>({
    url: '/clue/list',
    data: {
      company_name: '',
      page: 1,
      page_size: 10000
    }
  }).then((res) => {
    if (res.data?.data && res.data?.data.length > 0) {
      bindCompanyOptions.value = res.data.data.map((item) => ({
        value: item,
        label: item.company_name
      }))
      bindCompanyDialog.value = true
    } else {
      ElMessage.error('你还没有已分配企业')
    }
  })
}
const handleSelectCompany = () => {
  if (!bindCompany.value) {
    ElMessage.error('请选择要绑定的企业')
    return
  }
  $post<Selections>({
    url: '/clue/hr',
    data: {
      clue_id: bindCompany.value.id || ''
    }
  }).then((res) => {
    hrList.value = res.data.hr || []
    bindCompanyDialog.value = false
    bindUserDialog.value = true
  })
}
const addHr = () => {
  hrList.value.push({
    id: 0,
    mobile: '',
    nickname: ''
  })
}
const checkHr = (i: number) => {
  const hr = hrList.value[i]
  if (!hr.nickname.trim()) {
    ElMessage.error('请填写姓名')
    return
  }
  if (!/^1[3456789]\d{9}$/.test(hr.mobile)) {
    ElMessage.error('手机号格式不正确')
    return
  }
  hrList.value[i].checkd = !hrList.value[i].checkd
}
const handleBindHr = () => {
  const selHrList = hrList.value.filter(item => {
    return item.checkd
  })
  if (selHrList.length <= 0) {
    ElMessage.error('请选择账号')
    return
  }
  copyText(hrProductUrl.value, false)
  $post<Selections>({
    url: '/selection/hr/bind',
    data: {
      clue_id: bindCompany.value.id || '',
      selection_id: selectionId.value,
      hr: selHrList
    }
  }).then(() => {
    ElMessage.success('链接已复制')
    bindUserDialog.value = false
  })
}
const copyText = (text:string, showMsg = true) => {
  const dom = document.createElement('textarea')
  dom.value = text
  dom.setAttribute('style', 'display: block;width: 1px;height: 1px;')
  document.body.appendChild(dom)
  dom.select()
  const result = document.execCommand('copy')
  document.body.removeChild(dom)
  if (result && showMsg) {
    ElMessage.success('链接已复制')
    return
  }
  if (typeof document.createRange !== 'function') {
    ElMessage.error('复制失败，请长按复制')
  }
  const range = document.createRange()
  const div = document.createElement('div')
  div.innerHTML = text
  div.setAttribute('style', 'height: 1px;fontSize: 1px;overflow: hidden;')
  document.body.appendChild(div)
  range.selectNode(div)
  const selection = window.getSelection()
  if (selection.rangeCount > 0) {
    selection.removeAllRanges()
  }
  selection.addRange(range)
  document.execCommand('copy')
  if (showMsg) {
    ElMessage.success('链接已复制')
  }
}
const { tableData, pageSizeOpt } = toRefs(state)

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "container" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, null, {
        default: _withCtx(() => [
          _createVNode(_unref(Header), {
            onSearch: search,
            inputPlaceholder: "请输入选品单名称"
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_el_button, {
          type: "primary",
          class: "del",
          onClick: navProducts
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_table, {
          data: _unref(tableData),
          class: "i-table",
          height: "100%",
          "empty-text": "暂无数据",
          "cell-class-name": cellClass,
          "header-cell-class-name": headerCellClass
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "selection_name",
              label: "选品单名称"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.selection_name || "未命名"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "created_at",
              label: "创建时间"
            }),
            _createVNode(_component_el_table_column, {
              prop: "updated_at",
              label: "更新时间"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.updated_at || "无"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "420"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (handleEdit(scope.row.id))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_link, {
                  type: "primary",
                  style: {"margin":"0 12px"},
                  onClick: ($event: any) => (navPreOrder(scope.row.id))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (handleDownload(scope.row.id))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_link, {
                  style: {"margin-left":"12px"},
                  type: "primary",
                  onClick: ($event: any) => (handleBindCompany(scope.row.id))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_el_select, {
            modelValue: pageSize.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageSize).value = $event)),
            class: "sel-page-size",
            placeholder: "Select",
            size: "large"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageSizeOpt), (item, i) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: i,
                  label: item,
                  value: item
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _hoisted_12,
          _createTextVNode(_toDisplayString(total.value) + "个选品单", 1),
          _hoisted_13
        ]),
        _createVNode(_component_el_pagination, {
          currentPage: pageIndex.value,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((pageIndex).value = $event)),
          "page-size": pageSize.value,
          "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => ((pageSize).value = $event)),
          background: "",
          layout: "prev, pager, next",
          total: total.value,
          "pager-count": 6
        }, null, 8, ["currentPage", "page-size", "total"])
      ]),
      _createVNode(_component_el_dialog, {
        modelValue: bindCompanyDialog.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((bindCompanyDialog).value = $event)),
        title: "选择绑定企业",
        width: "400px",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_14, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: handleSelectCompany
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_select_v2, {
            modelValue: bindCompany.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((bindCompany).value = $event)),
            filterable: "",
            options: bindCompanyOptions.value,
            placeholder: "请选择绑定企业",
            style: {"width":"100%"}
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: bindUserDialog.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((bindUserDialog).value = $event)),
        title: "选择开通账号",
        width: "500px",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_24, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (copyText(hrProductUrl.value)))
            }, {
              default: _withCtx(() => [
                _hoisted_25
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: handleBindHr
            }, {
              default: _withCtx(() => [
                _hoisted_26
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_scrollbar, {
            "max-height": "400px",
            class: "bind-user-dialog"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("h2", null, _toDisplayString(bindCompany.value.company_name), 1),
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  onClick: addHr
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                })
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hrList.value, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "wrap"
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createVNode(_component_el_input, {
                        modelValue: item.nickname,
                        "onUpdate:modelValue": ($event: any) => ((item.nickname) = $event),
                        disabled: item.id>0,
                        placeholder: "请输入姓名",
                        clearable: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createVNode(_component_el_input, {
                        modelValue: item.mobile,
                        "onUpdate:modelValue": ($event: any) => ((item.mobile) = $event),
                        placeholder: "请输入手机号",
                        clearable: "",
                        disabled: item.id>0,
                        oninput: "value = value.replace(/[^0-9]/g, '')",
                        maxlength: "11"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_el_button, {
                      type: !item.checkd?'primary':'info',
                      size: "small",
                      onClick: ($event: any) => (checkHr(i))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.checkd ? "已选择" : "确认"), 1)
                      ]),
                      _: 2
                    }, 1032, ["type", "onClick"])
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: dialogSelectionVisible.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dialogSelectionVisible).value = $event)),
        width: "94%",
        top: "7.5vh",
        title: "报价单",
        "custom-class": "pre-order-dialog",
        onClose: dialogSelectionClose,
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(PreOrder), {
            ref_key: "preOrderRef",
            ref: preOrderRef,
            id: selectionId.value,
            onBack: closeSelectionDialog
          }, null, 8, ["id"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})